import { t } from "ember-intl";
import Label from "glesys-controlpanel/components/label";
import Copyable from "glesys-controlpanel/components/copyable";
import AlertMessage from "glesys-controlpanel/components/alert-message";

<template>
  <AlertMessage @type="information">
    {{t "component.password-reveal.warning"}}
  </AlertMessage>
  <div class="mt-4">
    <Label>{{t "component.password-reveal.password-label"}}</Label>
    <Copyable
      class="block font-mono text-sm bg-gray-50 p-2 rounded-sm border border-gray-200 break-all"
      data-test-password-reveal-password
    >{{@password}}</Copyable>
  </div>
</template>
